import React, {useState} from 'react';
import axios from "axios";
import swal from 'sweetalert';

const baseURL = "https://www.intellisaving.com/api.php";


export default function Subscription() {
  
  // const [setPost] = React.useState(null);
  const [email,setEmail] = useState("");
  
  const submit = (e)=>{
     e.preventDefault();
     if(!email){
        swal("Error",'Email is required',"error");
     }

     axios.post(baseURL, {
        email: email
      })

      .then((res) => {
        if(res.data.status === 200){
          swal("Success",res.data.message,"success");
          document.getElementById('Email').value = ''
        }else if(res.data.status === 400){
          swal("Success",res.data.message,"success");
          document.getElementById('Email').value = ''
        }
        else{
           swal("Error","Something went wrong, Please try again.","error");
           document.getElementById('Email').reset();
        }
      });
     
    }
  
    return (
    <div>
    <section className="section-pading py-4">
  <div className="container">
    <div className="row">
      <div className="col-sm-12">
        <div className="newsletter-area py-3">
          <div className="row">
            <div className="col-sm-5">
              <p className="newsletter-text">Don't miss any update, Subscribe yourself now.</p>
            </div>
            <div className="col-sm-7">
              <form onSubmit={submit} className="d-flex" id="email_form">
              <input type="text" name="email" id="Email" value={email} onChange={(e)=>setEmail(e.target.value)} className="newsletter-input" placeholder="Email Address"/>
              <button className="newsletter-btn" type="submit">Subscribe</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
</section>
    </div>
  );
}